import { defineStore } from 'pinia';
import { ref } from 'vue';

export type NotificationType = 'error' | 'warning' | 'success' | 'info';

export interface Notification {
  message: string;
  type: NotificationType;
}

export const useNotificationStore = defineStore('notifications', () => {
  const notification = ref<Notification | null>(null);
  const visible = ref(false);

  function show(message: string, type: NotificationType = 'error') {
    notification.value = { message, type };
    visible.value = true;
  }

  function showError(message: string) {
    show(message, 'error');
  }

  function showSuccess(message: string) {
    show(message, 'success');
  }

  function dismiss() {
    visible.value = false;
  }

  return { notification, visible, show, showError, showSuccess, dismiss };
});
